export default __webpack_public_path__ + "static/media/externalLink.12ebbde2.svg";